import React, { forwardRef } from 'react';
import { cn } from './cn';

const ChatComposer = forwardRef(function ChatComposer({ active, title, children, ...props }, ref) {
  return <div {...props} ref={ref} className={cn('relative w-full rounded-bun-xl border border-bun-line bg-bun-surface font-instrument shadow-bun-card focus-within:border-bun-blue focus-within:ring-[3px] focus-within:ring-bun-ring', active && 'border-bun-blue ring-[3px] ring-bun-ring')}>
    {title && <div className="px-4 pt-3 text-bun-body font-semibold text-bun-text">{title}</div>}
    {children}
  </div>;
});

const Input = forwardRef(function Input({ className, rows = 2, ...props }, ref) {
  return <textarea rows={rows} {...props} ref={ref} className={cn('block max-h-52 w-full resize-none overflow-y-auto rounded-bun-xl border-0 bg-transparent px-4 pt-4 pb-2 font-instrument text-[16px] font-book leading-[1.75] text-bun-text placeholder:text-bun-faint focus:outline-none focus:ring-0', rows === 1 ? 'min-h-[52px]' : 'min-h-[88px]', className)} />;
});

function Toolbar({ children, actions }) {
  return <div className="flex items-end justify-between gap-2 px-[10px] pt-2 pb-[10px]"><div className="flex min-w-0 flex-wrap items-center gap-1">{children}</div><div className="flex shrink-0 items-center gap-1">{actions}</div></div>;
}

ChatComposer.Input = Input;
ChatComposer.Toolbar = Toolbar;
export default ChatComposer;
